// CAREERS PAGE

import React from 'react'

function Careers() {
  return (
    <div>
      This is the careers page.
    </div>
  )
}

export default Careers
